import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { IndividuService } from '@Common/core/services';
import { Observable } from 'rxjs';


@Injectable()
export class CheckGuardService  {
  roles: [];
  grantedUser = false;
  params: {};
  constructor(private individuService: IndividuService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.roles = route.data?.roles || this.roles;
    this.params = route.data?.params || this.params;
    return this.isGranted();
  }

  private isGranted(): Observable<boolean> {
    return new Observable(observer => {
      this.individuService.individu$.subscribe(_individu => {
        observer.next(this._isGranted(_individu));
        observer.complete();
      });
    });
  }

  private _isGranted(individu) {
    if (this.roles.length > 0) {
      this.roles.forEach(role => {
        if (this.individuService.hasRole(individu,  role)) {
          return this.grantedUser = true;
        }
      });
    }
    if (this.grantedUser) {
      return true;
    }
    this.router.navigateByUrl('/forbidden', {state: this.params});
    return false;
  }

}
